import React from "react";
import "./AnalyticsDashboard.css";
import image from "../logos/analytics.png";

const AnalyticsDashboard = () => {
  return (
    <div className="mainContainer">
      <header>
        <figure>
          <a href="mailto:support@elhi.tech?subject=truRooms Meeting Report">
            <img className="img" src={image} alt="Logo" />
          </a>
        </figure>
      </header>
    </div>
  );
};

export default AnalyticsDashboard;
